<script>
    import { installation_notice_status, current_lang } from '../stores.js';
    import {push} from 'svelte-spa-router'

    let lang_set = false;

	function set_installation_notice_status(status) {
        installation_notice_status.set(status);
    }

    function show_instructions(){
        set_installation_notice_status(1);
        push("/instructions/");
    }

    function close_notification(){
        set_installation_notice_status(1);
    }

    function select_fi(){
        $current_lang = "FI";
        lang_set = true;
    }

    function select_en(){
        $current_lang = "EN";
        lang_set = true;
    }
</script>
<div class="notice-container">
    <div class="notice-window">
        {#if lang_set }
            {#if $current_lang == "FI"}
                <div class="text">
                    <h3>Tämä sovellus on asennettavissa laitteellesi</h3>
                    <p>Voit siirtyä asennusohjeeseen tai sulkea tämän ilmoituksen ja jatkaa sovelluksen käyttöä ilman asennusta. Asennusohjeen voit lukea myöhemmin asetukset-valikosta.</p>
                </div>
                <div class="buttons">
                    <div class="simplebutton" on:click={show_instructions}>OK, näytä ohjeet</div>
                    <div class="simplebutton" on:click={close_notification}>Sulje ilmoitus</div>
                </div>
            {/if}
            {#if $current_lang == "EN"}
                <div class="text">
                    <h3>This app can be installed on your device</h3>
                    <p>You can find the installation instructions below. The instructions can also be found later from the settings-menu if you close this notification.</p>
                </div>
                <div class="buttons">
                    <div class="simplebutton" on:click={show_instructions}>OK, show instructions</div>
                    <div class="simplebutton" on:click={close_notification}>Close notification</div>
                </div>
            {/if}
        {:else}
        <div class="text">
            <h3>Kieli / Language</h3>
        </div>
        <div class="buttons no-space">
            <div class="simplebutton" on:click={select_fi}>Suomi</div>
            <div class="simplebutton" on:click={select_en}>English</div>
        </div>
        {/if}
    </div>
</div>
<style>
    h3{
        margin-bottom: 15px;
        font-size: 1.2rem;
        flex-grow: 1;
        margin-top: 0;
    }
    p{
        font-size: 1rem;
    }
    .text p:last-of-type{
        margin-bottom: 0;
    }
    .notice-container{
        background: none;
        position: fixed;
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 100;
        background-color: rgba(0,0,0,0.5);
    }
    .notice-window{
        background: #fff;
        color: #000;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 90%;
        min-height: 60px;
        border-radius: 4px;
        padding: 0 15px;
        box-sizing: border-box;
        max-width: 500px;
    }
    .text{
        flex-grow: 1;
        margin-top: 15px;
    }
    .buttons{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
        margin-bottom: 15px;
    }
    .buttons.no-space{
        justify-content: center;
        margin-top: 15px;
    }

    .buttons.no-space .simplebutton:not(:first-of-type){
        margin-left: 30px;
    }

    .buttons.no-space .simplebutton{
        min-width: 60px;
    }
</style>